import { FormApi } from 'final-form'
import { FieldMetaState } from 'react-final-form'

/**
 * Return the current field's active error.
 *
 * @param meta The react-final-form field meta state.
 */
export const getFieldError = (meta: FieldMetaState<any>): any => {
  return (meta.touched && meta.error) || (!meta.dirtySinceLastSubmit && meta.submitError)
}

/**
 * Return the current field's active error without check if it's touched or dirty.
 *
 * @param meta The react-final-form field meta state.
 */
export const getSimpleFieldError = (meta: FieldMetaState<any>): any => meta.error || meta.submitError

/**
 * Returns true if any field on @param formApi is marked as touched, otherwise, returns false
 *
 * @param formApi The FormApi from react-final-form.
 */
export const anyFieldIsTouched = (formApi: FormApi): boolean => {
  return (
    formApi
      .getRegisteredFields()
      .map((field) => formApi.getFieldState(field).touched)
      .filter((value) => value).length > 0
  )
}
